import { RWG_COOKIE } from 'utils/partner';
// Dynamic keys not included - https://github.com/spothero/consumer-web/blob/c363819f97bebeea2526eb4bcee3d8db42bb094f/src/js/pages/search/hooks/use-tooltips.ts#L49
const SESSION_UUID = 'sh-session-uuid';
export const StorageKeys = {
    PARTNER_AFFILIATE: 'sh-partner-affiliate',
    SEEN_LOYALTY_PROGRAM_INFO_COOKIE: 'seen-loyalty-program-info',
    SEARCH_START_TIME: 'searchStartTime',
    RWG_COOKIE, // TODO This was not standardized as it felt like un-needed doubling
    ANALYTICS_SEARCH_UUID_COOKIE: 'sh-analytics-search-uuid',
    SESSION_UUID, // Open Question, this string is in 3 places in this document
    EXPERIMENT_VARIATIONS: 'sh-experiment-variations',
    EXPERIMENTID: 'sh-web-experiment-id',
    VISITOR_TYPE: 'sh-web-vt',
    PREVIOUS_SEARCH: 'previous-search',
    TTFR_TRACKED: 'sh-ttfr-tracked',
    AUTH: {
        COOKIES: {
            AUTH_TOKEN: 'AUTH_TOKEN',
            SESSION_ID: 'sessionid',
            SESSION_UUID: 'sh-session-uuid',
            IMPERSONATE: 'IMPERSONATE',
            SH_LOGOUT: 'sh-slo',
            SH_GUEST: 'sh-auth-guest',
            AUTH_SUB_ID: 'sh-sso',
        },
    },
    SEARCH_TRACKING: {
        COOKIES: {
            SESSION_UUID_COOKIE: 'sh-session-uuid',
            SEARCH_UUID_COOKIE: 'sh-search-uuid',
            ACTION_UUID_COOKIE: 'sh-action-uuid',
            ACTION_COOKIE: 'sh-action-id',
        },
    },
    SEARCH_VEHICLES: {
        VEHICLE_STORAGE_KEY: 'search_vehicle_info',
        VEHICLE_STORAGE_TYPE: 'session',
        POPOVER_STORAGE_KEY: 'search_vehicle_popover_visible',
        POPOVER_STORAGE_TYPE: 'session',
    },
    SEARCH_GOOGLE_PLACES_TYPE: {
        STORAGE_KEY: 'search_google_places_type',
        STORAGE_TYPE: 'session',
    },
    SEARCH_SCROLL_POSITION: {
        STORAGE_KEY: 'search_scroll_position',
        STORAGE_TYPE: 'session',
    },
    TOTAL_PRICE: {
        TOTAL_PRICE_SESSION_PREFERENCE: 'total_price_session_preference',
        TOTAL_PRICE_SESSION_PREFERENCE_STORAGE_TYPE: 'session',
    },
    ROKT_SESSION_STORAGE_KEY: 'display-rokt',
    ACTIVE_AMENITIES: 'sh-active-amenities',
    EXPOSED_TO_AIRPORT_WAITTIME: 'exposed-to-airport-waittime',
};
export const StorageTypes = {
    LOCAL: 'local',
    SESSION: 'session',
    COOKIE: 'cookie',
};
export const StorageDurations = {
    YEAR: 365,
    YEAR_IN_MILLISECONDS: 1000 * 60 * 60 * 24 * 365, // One year in milliseconds
    MONTH: 30,
    HALF_HOUR_IN_DAYS: 0.021,
};
